import React from 'react';
import { sanitizeText } from './ShareButtonUtils';
import Icon from 'buyside/components/presentation/Icon/icon';
import FacebookIcon from 'buyside/svgs/social_media/facebook_icon.svg';
import styles from './shareButtonStyles';
// https://developers.facebook.com/docs/plugins/share-button/
const FacebookButton = ({ shareUrl }) => {
  return (
    <div>
      <div
        className="fb-share-button"
        data-href={shareUrl}
        data-layout="button"
        data-size="small"
        data-mobile-iframe="true"
      >
        <a
          target="_blank"
          href={`https://www.facebook.com/sharer/sharer.php?u=${sanitizeText(
            shareUrl
          )}&amp;src=sdkpreparse`}
          className="fb-xfbml-parse-ignore"
        >
          <Icon type={FacebookIcon} className={styles.shareButton} />
        </a>
      </div>
    </div>
  );
};

export default FacebookButton;
